<div class="container-fluid">
    <div class="signup-width">
    <div class="row">
        <div class="col-lg-6 col-md-6 signup-left">
              <div class="text-left">
                    <img src="assets/images/nri-logo.png" alt="logo" class="logo">
                </div>
              <h2> Service Provider Sign Up</h2>
              <p class="left-text">Join thousands of NRIs and service providers connecting globally</p>
              <div class="row">
                  <div class=" position-relative col-md-12">
                      <div class="position-relative">
                          <app-text-input label="Business Name" placeholder="Business Name" [control]="getControl('business_name')" ></app-text-input>
                      </div>
                  </div>
                  <div class=" position-relative col-md-6 ignup-left">
                      <div class="position-relative">
                          <app-text-input label="First Name" placeholder="First Name" [control]="getControl('firstName')" ></app-text-input>
                      </div>
                  </div>
                    <div class=" position-relative col-md-6">
                      <div class="position-relative">
                          <app-text-input label="Last Name" placeholder="Last Name" [control]="getControl('lastName')" ></app-text-input>
                      </div>
                  </div>
                 <div class=" position-relative col-md-6">
                      <div class="position-relative">
                          <app-text-input label="Email Address" placeholder="Email Address" [control]="getControl('email')" ></app-text-input>
                      </div>
                  </div>
                   <div class=" position-relative col-md-6">
                      <div class="position-relative">
                          <app-text-input label="Phone Number" placeholder="Phone Number" [control]="getControl('mobileNumber')" ></app-text-input>
                      </div>
                  </div>
                  <div class=" position-relative col-md-6">
                      <div class="position-relative">
                          <app-text-input label="City" placeholder="City" [control]="getControl('city')" ></app-text-input>
                      </div>
                  </div>
                  <div class="col-md-6 signup-hide">
                  
                        <label class="form-label" style="margin-bottom: 0;">Area of Expertise</label>
                        <mat-form-field appearance="outline" class="w-100" floatLabel="always">
  
    <mat-select [formControl]="getControl('expertise')" multiple class="form-control expert-control">
      <mat-option *ngFor="let topping of expertiseOptions" [value]="topping">{{topping}}</mat-option>
    </mat-select>
  </mat-form-field>
                    
                  </div>
                   <div class=" position-relative col-md-6">
                      <div class="position-relative">
                          <app-text-input label="Sub-Services You Offer" placeholder="Sub-Services You Offer" [control]="getControl('sub_service')" ></app-text-input>
                      </div>
                  </div>
                  <div class=" position-relative col-md-6">
                      <div class="position-relative">
                      <app-select label="Experience Level"  placeholder="-- Select --" [control]="getControl('experience')"
                      [options]="experienceLevelOptions"></app-select>
                      </div>
                  </div>
                  <div class="position-relative col-md-6">
                      <div class="position-relative">
                      <app-select label="Availability"  placeholder="-- Select --" [control]="getControl('availability')"
                      [options]="availabilityOptions"></app-select>
                      </div>
                  </div>
  
                  <div class=" position-relative col-md-6">
                      <div class="position-relative">
                      <app-select label="How did you hear about us?"  placeholder="-- Select --" [control]="getControl('hear_about')"
                      [options]="hearOptions"></app-select>
                      </div>
                  </div>
                   <div class="position-relative col-md-6 date-verification">
                    <label class="form-label">Short Verification Call</label>
                              <mat-form-field appearance="outline" class="w-100">
    <input matInput [matDatepicker]="picker" formControlName="verify_date">
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  
                  </div>
                  <div class="position-relative col-md-6">
                   <label class="form-label">Preferred Time</label>
                  <div class="row">
                      <div class="col-lg-6">
                           <input type="time" class="form-control" [formControl]="getControl('preferred_time')" />
                      </div>
                 <div class="col-lg-6 mt-minus">
                   <app-select label=""  placeholder="-- Select --" [control]="getControl('changePeriod')"
                      [options]="timeOptions"></app-select>
                 </div>
                  </div>
                </div>
                  <div class="mb-0 position-relative  col-md-6">
                      <div class="position-relative password-wrapper">
                          <div style="width: 100%;">
                          <app-text-input label="Password" placeholder="Password" (keyup.enter)="signUp()" [type]="isPasswordVisible ? 'text' : 'password'" [control]="getControl('password')" (input)="onPasswordInput()"></app-text-input>
                          <i class="fa" [ngClass]="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'" (click)="togglePasswordVisibility()"></i>
  
                      </div>
                      </div>
                  </div>
                   <div class="mb-0 position-relative col-md-6">
                      <div class="position-relative password-wrapper">
                          <div style="width: 100%;">
                                                  <app-text-input label="Confirm Password" placeholder="Confirm Password" (keyup.enter)="signUp()" [type]="isPasswordVisible ? 'text' : 'password'" [control]="getControl('confirmPassword')" (input)="onPasswordInput()"></app-text-input>
                                                  <i class="fa" [ngClass]="isPasswordVisible ? 'fa-eye' : 'fa-eye-slash'" (click)="togglePasswordVisibility()"></i>
                                                  <div *ngIf="passwordMismatch && getControl('confirmPassword').dirty" class="text-danger mt-1" style="font-size: 13px;">
                                                      Password and Confirm Password do not match
                                                  </div>
  
                      </div>
                      </div>
  
                  </div>
  
              </div>
              <div class="signup-btn mt-8">
                <button class="btn btn-primary width-100"  (click)="signUp()">
                       <span class="fa-spin-position"> Sign Up
                        <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                      </span>
                      </button>
              </div>
              <p class="mt-3 mb-4 text-center">Already have an account? <a href="#" class="signin-link">Sign In</a></p>
        </div>
   <div class="col-lg-6 col-md-6 signup-right">
            <div class="text-center">
                <img src="assets/images/service-provider-signup.png" alt="signup" class="signup-image">
                <h3>Connect. Grow. Succeed.</h3>
  <p class="right-text">Join our global network of NRIs and trusted service providers.</p>
  <ul class="features-list mt-8">
   <li><span>50K+</span> Verified NRI Users</li>
    <li><span>500+</span> Active Communities & Groups</li>
    <li><span>95%</span> Successful Signup Requests</li>
  </ul>
        </div>
  
    </div>
  </div>
  </div>
  
  